import * as angular from "angular";
import {NavigationMenu} from "../models/navigation-menu/navigation-menu.model";
import {LayoutWindow, LayoutUser} from "../models/layout-window.model";
import {UserSessionService} from "../common/user-session/user-session.service";
import {InsightsPopoverService} from "../insights/insights-popover.service";
import {GroupsInit} from "../groups/groups-init/groups-init.service";
import {DataLayer} from "../models/data-layer.model";

export interface LayoutInitService { (initData?: GroupsInit): void; }

/* @ngInject */
export function layoutInitService(
  $window: angular.IWindowService,
  userSessionService: UserSessionService,
  FEATURE_TOGGLE: Object,
  insightsPopoverService: InsightsPopoverService
): LayoutInitService {
    return ((initData?: GroupsInit) => {
        const succeedLayout = ($window as LayoutWindow).succeedLayout;

        let navigationMenu: NavigationMenu = userSessionService.getNavigationMenu();
        if (navigationMenu) {
          succeedLayout.createNav(
                navigationMenu.topLevelNavItems,
                navigationMenu.setupItems,
                navigationMenu.helpItems,
                navigationMenu.communityUrl
            );
        }
        let layoutUser: LayoutUser = userSessionService.getLayoutUser();
        if (layoutUser) {
          succeedLayout.showUserInfo(layoutUser);
        }
        if (succeedLayout && succeedLayout.applyToggles) {
          succeedLayout.applyToggles(FEATURE_TOGGLE);
        }

        if (initData) {
          if (FEATURE_TOGGLE["naviance.insights.navigation_popovers"]) {
            if (
              initData.district ||
              (initData.institution && (initData.institution.level === "high" || initData.institution.level === "combined"))
            ) {
              const accessLevel = initData.district ? "district" : "school";

              insightsPopoverService.isAnalyticsPopoverDisplayed(accessLevel).then(state => {
                if (state) {
                  succeedLayout.displayAnalyticsPopover(initData.district ? "bottom" : "right", () => {
                    insightsPopoverService.refreshAnalyticsPopoverDisplay(accessLevel);
                  });
                }
              });

              insightsPopoverService.isInsightsPopoverDisplayed(accessLevel).then(state => {
                if (state) {
                  succeedLayout.displayInsightsPopover();
                }
              });
            }
          }
          if (succeedLayout && succeedLayout.googleTagManagerDataLayerInfo) {
            const dataLayer: DataLayer = {
              userId: initData.currentUser.userId,
              institution: initData.institution.institutionId,
              institutionName: initData.institution.name
            }
            succeedLayout.googleTagManagerDataLayerInfo(dataLayer);
          }
        }
    });
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/layout-init/layout-init.service.ts
 **/